import Service, { LoanService, AuthService } from '@/utils/service'

export const loginByMobile = ({
  mobile = '',
  smsCode = ''
}) => {
  return new AuthService({
    url: '/api/login/sms',
    method: 'post',
    needToken: false,
    data: {
      mobile: mobile,
      smsCode: smsCode
    }
  })
}
export const sendSmsCode = (params = {
  mobile: '',
  captcha: ''
}) => {
  return new AuthService({
    url: '/api/login/sms',
    method: 'get',
    needToken: false,
    data: {
      mobile: params.mobile,
      captcha: params.captcha
    }
  })
}
export const checkLogin = (params = {
  username: '',
  token: ''
}) => {
  return new LoanService({
    url: '/loan/token/login',
    method: 'post',
    data: {
      username: params.username,
      token: params.token
    }
  })
}
export const sso = (params = {
  token: '',
  sign: '',
  timestamp: Date.now()
}) => {
  return new AuthService({
    url: '/api/user/token',
    method: 'post',
    data: {
      token: params.token,
      sign: params.sign,
      timestamp: params.timestamp
    }
  })
}
export const logout = () => {
  return new AuthService({
    url: '/api/user/logout',
    method: 'get'
  })
}
